import { CommentAPI } from "../api";
export class Comment {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createComment(payload) {
    const { data } = await CommentAPI.createComment(payload);
    return new Comment(data.result);
  }
  static async getCommentByPost({ postId }) {
    const { data } = await CommentAPI.getCommentByPost({ postId });
    return new Comment(data.result);
  }
}
